<template>
  <div>
    <v-subheader>Passengers</v-subheader>
    <v-simple-table dense>
      <tbody>
      <tr>
        <td class="grey--text">Commercial Business</td>
        <td>{{ value.pax.c }}</td>
      </tr>
      <tr>
        <td class="grey--text">Commercial Economy</td>
        <td>{{ value.pax.y }}</td>
      </tr>
      <tr>
        <td class="grey--text">ID Business</td>
        <td>{{ value.pax.idC }}</td>
      </tr>
      <tr>
        <td class="grey--text">ID Economy</td>
        <td>{{ value.pax.idY }}</td>
      </tr>
      <tr>
        <td class="grey--text font-weight-bold">Commercial Total</td>
        <td>{{ value.pax.totalCommercial }}</td>
      </tr>
      <tr>
        <td class="grey--text font-weight-bold">ID Total</td>
        <td>{{ value.pax.id }}</td>
      </tr>
      <tr>
        <td class="grey--text font-weight-bold">Total</td>
        <td>{{ value.pax.total }}</td>
      </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>

export default {
  name: 'FlightInfoPax',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  components: {
  },
  methods: {
  },
  computed: {
  }
}
</script>
